import {FC, useState} from 'react';
import { SearchButtonPanel} from '../buttons/iconButtons/action/MainCollection';
import {TextInput} from '../controls/inputs';
import {Select, IOption} from '../selects/select';
import styles from './styles/BaseCommandsPanel.module.scss';
import { useTranslation } from 'react-i18next';

interface ISearchModalPanel {
  searchQuery: string;
  onChange: (value: string) => void;
  onClickOnSearchButton: () => void;
  onSelect: (option: IOption) => void;
  onFocusChanged?: (taken: boolean) => void;
  defaultOptionFilter: IOption;
  options?: IOption[]
  hasActiveFilters?: boolean
}

export const SearchModalPanel: FC<ISearchModalPanel> = (props) => {
  const [searchValue, setSearchValue] = useState<string>(props.searchQuery);

  const { t } = useTranslation();

  return (
    <div className={styles.searchField}>
      <div className={styles.searchField_SearchIcon} style={props.hasActiveFilters ? { backgroundColor: 'rgb(153, 204, 255)', borderRadius: "2px", marginRight: 5 } : {marginRight: 5}}>
        <SearchButtonPanel sizeVariant="mini" onClick={() => props.onClickOnSearchButton()} />
      </div>
      <TextInput
        inline
        className={styles.searchField_SearchInput}
        label={t("general.search")} //'Поиск'
        value={searchValue}
        searchButtonShow={true}
        onFocus={() => {
          props.onFocusChanged?.(true);
        }}
        onEndChange={() => {
          props.onFocusChanged?.(false);
        }}
        onChange={(value: string) => {
          setSearchValue(value);
        }}
        searchButtonOnClick={() => {
          props.onChange(searchValue);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') { 
            props.onChange(searchValue);
          }
        }}
      />
      <Select
        onSelect={(option) => props.onSelect(option)}
        defaultOption={props.defaultOptionFilter}
        className={styles.searchField_TypeSearch}
        options={props.options ??
          [
          {displayName: 'Наименование товара', value: 'name'},
          {displayName: 'Код товара', value: 'goodsCode'},
        ]}
      />
      {props.children}
    </div>
  );
};
